/*
 * File: /src/store/modules/brands.js
 * Created Date: Tuesday December 14th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:46:13 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import BrandService from 'src/services/brandService';

const state = {
  brands: undefined
};

const getters = {
  getBrands: state => state.brands
};
const actions = {
  async fetchBrands({ commit, state }) {
    // Only load the data once
    if (state.brands == undefined) {
      return BrandService.fetchAll()
        .then(r => {
          commit('setBrands', r.data);
        });
    }
  },
  unloadBrands({ commit }) {
    commit('setBrands', undefined);
  },
};
const mutations = {
  setBrands(state, brands) {
    state.brands = brands;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
